import { Injectable } from '@angular/core';
import { BaseService } from './base.service';
import { Point } from "@models";

@Injectable()
export class PointService extends BaseService<Point> {
    override path = '/api/v1/points';
}
